<template lang="pug">
div
  modal.active(
    :active='showModal'
    @close='$router.back()',
    :title='`Desvincular documento Nº ${doc.numero}/${doc.ano}`'
  )
    div(slot='modal-body' v-if='doc')
      h5 Tem certeza?
      p Depois que confirmar o documento vai ser desvinculado da publicação e a situação volta para agurdando ciência.
    .columns.align-center(slot='modal-footer')
      .column
      .column-col-auto
        button.btn.btn-primary(
          :disabled='!docId',
          :class='{ loading }'
          @click='onConfirm'
        )
          btn-content(name='confirm' label="Desvincular")
</template>

<script>
import toastErrors from '@/lib/errors/toastErrors'

export default {
  vuex: {
    'fiscalizacao/docPublicacoes': {
      state: ['current', 'loading', 'status'],
      actions: ['fetchDetachDoc'],
    },
  },
  data() {
    return {
      showModal: true,
    }
  },
  computed: {
    docId() {
      return Number(this.$route.params.docId)
    },
    doc() {
      if (this.current && this.current.docs && this.current.docs.length) {
        return this.current.docs.find(d => d.id === this.docId) || {}
      }
      return {}
    },
  },
  methods: {
    async onConfirm() {
      try {
        const { id } = this.current
        await this.fetchDetachDoc({ id, docId: this.docId })
        this.$toaster.success('Desvnculado com sucesso')
        this.$router.back()
      } catch (e) {
        toastErrors(e)
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.list-filters
  position sticky
  top: -20px
  background-color #fff
  z-index 10
  padding-bottom 5px
</style>
